import { render, staticRenderFns } from "./my_visits.vue?vue&type=template&id=c81e2b9c&scoped=true&"
import script from "./my_visits.vue?vue&type=script&lang=js&"
export * from "./my_visits.vue?vue&type=script&lang=js&"
import style0 from "./my_visits.vue?vue&type=style&index=0&id=c81e2b9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81e2b9c",
  null
  
)

export default component.exports